import product1 from "./VRVF/VRVF.webp";
import product1Img1 from "./VRVF/img1.webp";
import product1Img2 from "./VRVF/img2.png";
import product1Img3 from "./VRVF/img3.jpg";
export const VirtualVisionProducts = [
  {
    id: 1,
    name: "Virtual Eye VRVF",
    title: "Virtual Eye VRVF",
    features: {
      feature1: "Employs immersive virtual reality technology for precise visual field examination.",
      feature2: "Streamlines clinical workflow, reduces testing time, and improves diagnostic accuracy.",
      feature3: "Creates a comfortable and engaging testing environment for patients of all ages.",
      feature4: "Offers detailed information about test parameters, including stimulus characteristics and response analysis."
    },
    images: {
      img1: product1Img1,
      img2: product1Img2,
      img3: product1Img3,
    },
    image: product1,
    link: "https://virtualvision.health/",
    description: "Elevate your visual field testing with Virtual Eye VRVF. Precise, patient-friendly diagnostics in an immersive experience.",
  },
];